import validate from "/builds/special/akinfeev/node_modules/nuxt/dist/pages/runtime/validate.js";
import redirects_45global from "/builds/special/akinfeev/app/middleware/redirects.global.ts";
import manifest_45route_45rule from "/builds/special/akinfeev/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  redirects_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "default-master-global-template": () => import("/builds/special/akinfeev/app/middleware/default.master.global.template.ts")
}